import React, { useState } from "react";
import {
  Button,
  TextField,
  Container,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";

const Footer = () => {
  return (
    <>
      <Box
        sx={{
          display: `flex`,
          justifyContent: `center`,
          alignItems: `center`,
          padding:'10px 0px',
          borderTop: `1px solid #E5E7EB`,
        }}
      >
        <Box component="a" href={""} className="footer">
          <Typography variant="span" component="span" className="">
            © 2026 MyNetGoals. All rights reserved.
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default Footer;
